import { createFileRoute, useParams } from '@tanstack/react-router';

import { QuizEditPage } from '@/views/admin/courses/quizzes/quiz-edit-page.tsx';

// 深层 quiz 编辑器。`quizzes_` 末尾的 `_` 使其脱离 quiz 列表路由
// （无 <Outlet/> 的终端组件）的嵌套，直接挂载在课程详情布局的
// <Outlet/> 下。URL 仍携带 `quizzes` 段使 tab shell 保持 Quizzes tab 高亮。
export const Route = createFileRoute('/admin/courses_/$id/quizzes_/$quizId/edit')({
  component: QuizEditRoute,
});

function QuizEditRoute() {
  const { id, quizId } = useParams({ from: '/admin/courses_/$id/quizzes_/$quizId/edit' });
  return <QuizEditPage courseId={id} quizId={quizId} />;
}
